/**
 * Ship Types and Crew Roles
 * Centralized definitions for ships
 */

// Ship types
export const SHIP_TYPES = [
  { id: 'galleon', label: 'Galleon' },
  { id: 'caravel', label: 'Caravel' },
  { id: 'sloop', label: 'Sloop' },
  { id: 'brigantine', label: 'Brigantine' },
  { id: 'schooner', label: 'Schooner' },
  { id: 'frigate', label: 'Frigate' },
  { id: 'longship', label: 'Longship' },
  { id: 'warship', label: 'Warship' },
  { id: 'merchant', label: 'Merchant Vessel' },
  { id: 'courier', label: 'Courier Vessel' },
  { id: 'luxury_passenger_liner', label: 'Luxury Passenger Liner' },
  { id: 'heavy_cargo_hauler', label: 'Heavy Cargo Hauler' },
  { id: 'heavy_arms_hauler', label: 'Heavy Arms Hauler' },
  { id: 'fishing', label: 'Fishing Boat' },
  { id: 'other', label: 'Other' },
]

// Crew roles
export const CREW_ROLES = [
  { id: 'owner', label: 'Owner' },
  { id: 'captain', label: 'Captain' },
  { id: 'first_mate', label: 'First Mate' },
  { id: 'quartermaster', label: 'Quartermaster' },
  { id: 'boatswain', label: 'Boatswain' },
  { id: 'navigator', label: 'Navigator' },
  { id: 'gunner', label: 'Gunner' },
  { id: 'surgeon', label: 'Surgeon' },
  { id: 'cook', label: 'Cook' },
  { id: 'deckhand', label: 'Deckhand' },
  { id: 'crew', label: 'Crew' },
  { id: 'passenger', label: 'Passenger' },
  { id: 'prisoner', label: 'Prisoner' },
  { id: 'former', label: 'Former Crew' },
]

// Helper functions
export function getShipType(id) {
  return SHIP_TYPES.find(t => t.id === id)
}

export function getShipTypeLabel(id) {
  const type = getShipType(id)
  return type?.label || 'Ship'
}

export function getCrewRole(id) {
  return CREW_ROLES.find(r => r.id === id)
}

export function getCrewRoleLabel(id) {
  const role = getCrewRole(id)
  return role?.label || id
}
